import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { ConglomeradoService } from "../habilitacao/conglomerado.service";
import { ParticipanteConglomerado } from "src/app/model/participante.conglomerado.model";
import { Cotista } from "src/app/model/cotista.model";

@Component({
    selector: 'label-participantes-conglomerado',
    templateUrl: './label-participantes-conglomerado.component.html',
    standalone: false
})
export class LabelParticipantesConglomerado implements OnChanges {
  @Input() idAgenteFinanceiro: number;
  @Output() public mostraLabel: EventEmitter<any> = new EventEmitter<any>();
  participantesConglomerado: ParticipanteConglomerado[] = [];
  mostrarLabel: boolean = false;

  constructor(private conglomeradoService: ConglomeradoService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.carregarParticipantesConglomerado();
  }

  async carregarParticipantesConglomerado() {
    console.log('AF selecionado: ', this.idAgenteFinanceiro);
    if (this.idAgenteFinanceiro != null) {
      this.participantesConglomerado = await this.conglomeradoService.buscarAtivosPorAgente(this.idAgenteFinanceiro).toPromise();
    }

    this.mostrarLabel = this.participantesConglomerado?.length > 0
    this.mostraLabel.emit(!!this.mostrarLabel);
  }
  
}
